import constants from '../Constants';
const {
  GET_TYPES,
  TYPES_LOADING,
  ADD_TYPE,
  ADD_TYPE_FAIL,
  UPDATE_TYPE,
  UPDATE_TYPE_FAIL,
  DELETE_TYPE,
  RESET_TYPES_ALERT,
  LOGOUT
} = constants;

const INIT_STATE = {
  types:{},
  typesMeta:{ total: false, lastPage: false, currentPage: 1, perPage: 20 },
  typesLoading: true,
  alert: { add: false, delete: false, edit: false, get: false },
  query: {},
};

const TypeReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_TYPES:
      const { data, query } = action.payload;
      const { entities, result } = data; 
      return {
            ...state, 
            types: entities.types, 
            typesMeta: {
                lastPage: result.last_page,
                total: result.total,
                currentPage: result.current_page,
                perPage: result.per_page,
                data: result.data,
            },
            typesLoading: false,
            query: query,
        };

    case TYPES_LOADING:
        return {
            ...state, 
            typesLoading: true,
        };
    
    case DELETE_TYPE:
        const { typesMeta, typesMeta: { data: metaData } } = state;

        const { [action.payload.toString()]: removed, ...rest } = state.types;
        
        metaData.splice(metaData.indexOf(action.payload), 1);
        
        const newMeta = { 
                ...typesMeta,
                data: metaData
            };
        
        return { 
            ...state,
            types: rest,
            typesMeta: newMeta
        };
    
    case ADD_TYPE:
        return {
            ...INIT_STATE,
            alert: { 
                ...INIT_STATE.alert,
                add: { 
                    type: "success",
                    message: "Type added successfully."
                }
            },
        };
    
    case ADD_TYPE_FAIL:
        return {
            ...state,
            alert: {
                 ...INIT_STATE.alert,
                add: { 
                    type: "warning",
                    message: action.payload
                }
            },
        };

    case UPDATE_TYPE:
        
        const types = {...state.types,[action.payload.id]: action.payload};
        return {
            ...state,
            types,
            alert: {
                ...INIT_STATE.alert,
                edit: { 
                    type: "success",
                    message: "Type updated successfully."
                    }
                }
            };

    case UPDATE_TYPE_FAIL:
        return {
            ...state,
            alert: {
                ...INIT_STATE.alert,
                edit: { 
                    type: "warning",
                    message: action.payload
                }
            },
        };

    case RESET_TYPES_ALERT:
        return {
            ...state,
            alert: INIT_STATE.alert,
        };

    case LOGOUT:
        return INIT_STATE;

    default:
        return state;

    }
}

export default TypeReducer;


// WEBPACK FOOTER //
// ./src/Reducers/TypeReducer.js